import { Box } from 'braid-design-system';
import React from 'react';

import {
  AdvertisersButton,
  AdviceAndTipsButton,
  BuyABusinessButton,
  FindBrokersButton,
  FranchiseButton,
  SellABusinessButton,
  MyPreferencesButton,
} from '../Dropdown/DropdownButtons';

import { DropdownMenuContainer } from './DropdownMenuContainer';
import { DropdownMenuDivider } from './DropdownMenuDivider';
import { RegisterTextLink, SignInTextLink } from './NavTextLink';

import * as styles from './DropdownMenuLoggedOut.css';

interface DropdownMenuLoggedOutProps {
  baseUrl: string;
}
export const DropdownMenuLoggedOut = ({
  baseUrl,
}: DropdownMenuLoggedOutProps) => (
  <DropdownMenuContainer>
    <BuyABusinessButton baseUrl={baseUrl} />
    <MyPreferencesButton baseUrl={baseUrl} />
    <SellABusinessButton baseUrl={baseUrl} />
    <FranchiseButton baseUrl={baseUrl} />
    <FindBrokersButton baseUrl={baseUrl} />
    <AdviceAndTipsButton baseUrl={baseUrl} />

    <DropdownMenuDivider />

    <Box display="flex" alignItems="center" paddingY="small">
      <SignInTextLink baseUrl={baseUrl} />
      <span className={styles.mobileMenuItemLoginSeparator} aria-hidden>
        {' '}
        or{' '}
      </span>
      <RegisterTextLink baseUrl={baseUrl} />
    </Box>

    <DropdownMenuDivider />

    <AdvertisersButton baseUrl={baseUrl} />
  </DropdownMenuContainer>
);
